import Modal from './Modal';
export { default as Header } from './Header';

export default Modal;
